export default __webpack_public_path__ + "static/media/insuranceOn.2b8f70ca.svg";